import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faExclamationCircle,
    faTimesCircle,
    faCheckCircle,
    faKey,
    faBook,
    faPlay,
    faPencilAlt,
    faCodeBranch,
    faChevronLeft,
    faChevronRight,
    faInfoCircle,
    faWrench,
    faPlug,
    faLock,
    faUser,
    faBuilding,
    faBolt,
    faDollarSign
} from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

library.add(
    faExclamationCircle,
    faTimesCircle,
    faCheckCircle,
    faKey,
    faBook,
    faPlay,
    faPencilAlt,
    faGithub,
    faCodeBranch,
    faChevronLeft,
    faChevronRight,
    faInfoCircle,
    faWrench,
    faPlug,
    faLock,
    faUser,
    faBuilding,
    faBolt,
    faDollarSign
);
